export const getStep = (pathname: string) => {
  if (pathname.includes('details')) {
    return '3';
  } else if (pathname.includes('results')) {
    return '2A';
  } else if (pathname.includes('favourites')) {
    return '2B';
  } else {
    return '1B';
  }
};
